exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shadows > *[data-v-b4f8d956] {\n  width: 100%;\n}\n.shadows > *[data-v-b4f8d956]:not(:last-child) {\n  margin-bottom: 0.5rem;\n}\n.radio-button[data-v-b4f8d956] {\n  position: absolute;\n  right: 0px;\n  top: -28px;\n  display: inline-block;\n  width: 1.5rem;\n  height: 1.5rem;\n  line-height: 1.5rem;\n  text-align: center;\n  background: var(--clr-bg-2);\n  color: var(--clr-content-2);\n}\n.radio-button[data-v-b4f8d956]:hover {\n  background: var(--clr-primary-shade-3);\n  -webkit-box-shadow: inset 0 0 0 1px var(--clr-primary-shade-1);\n          box-shadow: inset 0 0 0 1px var(--clr-primary-shade-1);\n}\n", ""]);

// exports
